import React, { useContext } from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import { DataContext } from "../context/DataContext";

/**
 * Overlay de carga: el logo de la empresa rodeado por el anillo de progreso.
 *
 * Portado del Loading de la rama Inver-Credit_Kevin, con el acento en el verde
 * de marca en lugar del azul. Antes aqui era un engranaje de FontAwesome de
 * 110px girando, con azules fijos ajenos a la paleta.
 *
 * El logo va sobre un disco blanco: los assets de esta rama son iconos de app
 * con relleno blanco horneado en el PNG, asi que el disco hace que ese blanco
 * se lea como parte del diseño y no como un recuadro pegado, igual que en el
 * badge del sidebar.
 */
const Loading = () => {
  const { isLoading, icon, isDarkMode } = useContext(DataContext);

  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        // Fondo translucido segun el tema en vez del negro fijo del Backdrop,
        // para que el contenido de atras siga leyendose mientras carga.
        backgroundColor: isDarkMode ? "rgba(7, 15, 34, 0.72)" : "rgba(238, 241, 247, 0.78)",
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Anillo giratorio */}
        <CircularProgress
          size={140}
          thickness={2.2}
          disableShrink
          sx={{
            color: "#12a35a",
            // Extremos redondeados: se ve mas limpio que el corte recto por defecto.
            "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
          }}
        />

        {/* Halo que late detras del logo, para que el pulso se note aunque el
            logo sea claro sobre fondo claro. */}
        <Box
          sx={{
            position: "absolute",
            width: 104,
            height: 104,
            borderRadius: "50%",
            backgroundColor: "#12a35a",
            animation: "crediHalo 1.8s ease-in-out infinite",
            "@keyframes crediHalo": {
              "0%, 100%": { transform: "scale(0.82)", opacity: 0.1 },
              "50%": { transform: "scale(1)", opacity: 0.22 },
            },
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          }}
        />

        {/* Disco blanco + logo de la empresa, con pulso */}
        <Box
          sx={{
            position: "absolute",
            width: 88,
            height: 88,
            borderRadius: "50%",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 18px -8px rgba(0,0,0,.35)",
            animation: "crediPulse 1.8s ease-in-out infinite",
            "@keyframes crediPulse": {
              "0%, 100%": { transform: "scale(0.9)", opacity: 0.85 },
              "50%": { transform: "scale(1.06)", opacity: 1 },
            },
            // Respeta a quien tenga reducidas las animaciones en su sistema.
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          }}
        >
          <Box
            component="img"
            src={icon}
            alt=""
            sx={{ width: 62, height: 62, objectFit: "contain" }}
          />
        </Box>
      </Box>
    </Backdrop>
  );
};

export default Loading;
